import * as THREE from 'three';

export type onCameraMoveCallback = (target: {
  lat: number;
  lon: number;
  phi: number;
  theta: number;
}) => void;
export type onCameraZoomCallback = (target: { zoomValue: number }) => void;
export enum ViewerMode {
  NORMAL,
  HALF_SCREEN,
  SPLIT_SCREEN,
  TIMELAPSE,
}
export interface ObservationData {
  title: string;
  value: string;
}
export enum ViewerScreenDirection {
  RIGHT,
  LEFT,
}

// Tile-based system types
export interface TileCoordinate {
  x: number;
  y: number;
  face: CubeFace;
  level: number;
}

export interface TileInfo extends TileCoordinate {
  url: string;
  priority: number;
  isVisible: boolean;
  distance: number; // Distance from camera center for priority calculation
}

export enum CubeFace {
  FRONT = 'f',
  BACK = 'b',
  LEFT = 'r',
  RIGHT = 'l',
  UP = 'u',
  DOWN = 'd',
}

export interface LODLevel {
  level: number;
  tilesPerFace: number; // e.g., 1x1, 2x2, 4x4, 8x8
  fovThreshold: { min: number; max: number };
  priority: number;
}

export interface ViewportBounds {
  minX: number;
  maxX: number;
  minY: number;
  maxY: number;
  face: CubeFace;
}

export interface TileCache {
  texture: THREE.Texture;
  lastAccessed: number;
  level: number;
  size: number; // Memory size estimation
}

export interface TileLoadRequest {
  coordinate: TileCoordinate;
  priority: number;
  callback?: (texture: THREE.Texture) => void;
}

export interface CameraViewport {
  fov: number;
  aspect: number;
  horizontalAngle: number;
  verticalAngle: number;
  visibleFaces: CubeFace[];
}

export interface TileLevel {
  level: number;
  rows_per_face: number;
  cols_per_face: number;
  image_format?: 'png' | 'jpg' | null;
}

export interface TileConfig {
  url: string;
  levels: TileLevel[];
  sourceMode?: 'standard' | 'blurred';
}

export interface TileManagerConfig {
  metadata: TileConfig;
  lodLevels: LODLevel[];
  maxCacheSize: number; // in MB
  tilePadding: number; // Number of adjacent tiles to preload
  transitionBuffer: number; // FOV buffer for LOD transitions
}

export type onTileLoadCallback = (coordinate: TileCoordinate, texture: THREE.Texture) => void;
export type onTileErrorCallback = (coordinate: TileCoordinate, error: Error) => void;
export type onLODChangeCallback = (oldLevel: number, newLevel: number) => void;
